import React, { useState } from "react";
import "./myCustomer.css";
import Loader from "../MainComponent/loader";

export default function CustomerInfo() {
  const [loader] = useState(true);
  const [customerList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const processedCustomerList = customerList.reduce((unique, project) => {
    if(!project){
      return false
    }
    const index = unique.findIndex(
      (otherProject) =>
        project.value.customerName === otherProject.value.customerName &&
        project.value.customerEmail === otherProject.value.customerEmail &&
        project.value.customerPhoneNo.toString() === otherProject.value.customerPhoneNo.toString()
    );
    if (index !== -1) {
      unique[index].projects++;
    } else {
      unique.push({ ...project, projects: 1 });
    }
    return unique;
  }, []);
 

  const filteredCustomerList = processedCustomerList.filter(
    (item) =>
      item.value.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.value.customerEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.value.customerPhoneNo.toString().includes(searchTerm)
  );
  
  return (
    <>
      {loader ? (
        <Loader backgroundColor={"white"}></Loader>
      ) : (
        <div className="customerInfo">
          {(processedCustomerList.length > 0) ? (
            <div className="customerList">
              <form>
                <i className="bi bi-search"></i>
                <input
                  type="text"
                  placeholder="Search by name/PhoneNumber"
                  value={searchTerm}
                  onChange={handleSearchInputChange}
                ></input>
              </form>
              <div style={{ overflowX: "scroll", width: "100%" }}>
                <table>
                  <thead>
                    <tr>
                      <th>Customer Name</th>
                      <th>Phone Number</th>
                      <th>Email ID</th>
                      <th>Projects</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCustomerList.map((item, index) => (
                      <tr key={index}>
                        <td> {item.value.customerName} </td>
                        <td> {item.value.customerPhoneNo} </td>
                        <td> {item.value.customerEmail} </td>
                        <td> {item.projects}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="noCustomer">
              <img src="./images/Logos/Group.svg" alt="No Customer yet"></img>
              <h2>You don’t have any customers right now</h2>
            </div>
          )}
        </div>
      )}
    </>
  );
}
